import DocumentUploader from './document-uploader';

export default DocumentUploader;